import React from "react";
import styled from "styled-components";
import media from "../config/mediaQueries";

const Col = styled.div`
  margin-bottom: 3rem;
  ${media.desktop`
    flex: 0 0 45%;
  `};
`;

export default Col;



// WEBPACK FOOTER //
// ./src/components/Col.js